<template>
    <div class="mx-auto">
        <div class="card">
            <div class="card-header card-header bg-primary text-white h4 m-0">
                <page-title :title="$t(titleKey)"></page-title>
            </div>

            <div class="card-body">
                <kendo-datasource
                    ref="datasource1"
                    :transport="transportSettings"
                    :schema-model-id="'id'"
                    :schema-model-fields="schemaModelFields"
                    :schema-total="'total'"
                    :schema-data="'data'"
                    :page-size="gridOptions.pageable.size"
                    :server-paging="true"
                    :server-sorting="true"
                    :server-filtering="true"
                    :error="dataSourceError"
                    :requestEnd="datasorceRequestEnd"
                >
                </kendo-datasource>

                <kendo-grid
                    ref="grid"
                    :data-source-ref="'datasource1'"
                    :pageable="gridOptions.pageable"
                    :navigatable="gridOptions.navigatable"
                    :editable="gridOptions.editable"
                    :filterable="gridOptions.filterable"
                    :reorderable="gridOptions.reorderable"
                    :resizable="gridOptions.resizable"
                    :groupable="gridOptions.groupable"
                    :allow-copy="gridOptions.allowCopy"
                    :sortable-mode="gridOptions.sortable.mode"
                    :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                    :sortable-show-indexes="gridOptions.sortable.showIndexes"
                    :column-menu="gridOptions.columnMenu"
                    :selectable="gridOptions.selectable"
                    :scrollable="gridOptions.scrollable"
                    :dataBound="dataBound"
                >
                    <kendo-grid-column
                        :field="'id'"
                        :filterable="false"
                        :title="$t('auxiliary.gridHeaders.id')"
                        :hidden="true"
                    >
                    </kendo-grid-column>
                    <kendo-grid-column
                        :field="'name'"
                        :title="$t('auxiliary.gridHeaders.name')"
                        :hidden="isEnVersion"
                    >
                    </kendo-grid-column>
                    <kendo-grid-column
                        :field="'nameEn'"
                        :title="$t('auxiliary.gridHeaders.name')"
                        :hidden="!isEnVersion"
                    >
                    </kendo-grid-column>
                    <kendo-grid-column
                        :field="'active'"
                        :title="$t('auxiliary.gridHeaders.active')"
                        :template="activeCellTemplate"
                    >
                    </kendo-grid-column>
                    <kendo-grid-column
                        :field="'createdAt'"
                        :title="$t('createdOn')"
                        :format="dateTimeCustomFormat"
                    ></kendo-grid-column>
                    <kendo-grid-column
                        :field="'creatorUsername'"
                        :title="$t('createdBy')"
                    ></kendo-grid-column>
                    <kendo-grid-column
                        :field="'updatedAt'"
                        :title="$t('lastUpdatedOn')"
                        :format="dateTimeCustomFormat"
                    ></kendo-grid-column>
                    <kendo-grid-column
                        :field="'updaterUsername'"
                        :title="$t('lastUpdatedBy')"
                    ></kendo-grid-column
                    >
                    <kendo-grid-column
                        :template="btnsTemplate"
                        field="btnsColumn"
                        :title="$t('actions')"
                        :sortable="false"
                        :filterble="false"
                        :groupable="false"
                    >
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
import PageTitle from "../../components/common/PageTitle";
import service from "../../services/auxiliaryRegister.service";
import { mapGetters } from "vuex";

export default {
    components: {
        PageTitle,
    },
    props: {},
    data() {
        return {
            titleKey: "auxiliary.title",
            schemaModelFields: {
                id: {
                    name: "id",
                    type: "number",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                name: {
                    name: "name",
                    type: "string",
                    validation: { required: true },
                    editable: false,
                    nullable: false,
                    visible: true,
                },
                nameEn: {
                    name: "nameEn",
                    type: "string",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                active: {
                    name: "active",
                    type: "boolean",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                createdAt: {
                    name: "createdAt",
                    type: "date",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "date",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                creatorUsername: {
                    name: "creatorUsername",
                    type: "string",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
                updaterUsername: {
                    name: "updaterUsername",
                    type: "string",
                    editable: false,
                    nullable: true,
                    visible: true,
                },
            },
            transportSettings: {
                read: {
                    url:
                        this.$store.getters.baseUrl +
                        "/api/auxiliaryRegisters/list",
                    dataType: "json",
                    type: "POST",
                    contentType: "application/json",
                    beforeSend: this.beforeSend,
                },
                parameterMap: this.parameterMap,
            },
        };
    },
    methods: {
        dataBound(e) {},
        datasorceRequestEnd(e) {},
        dataSourceError(e) {
            this.$vs.notify({
                title: this.$t("notifications.error"),
                text: this.$helpers.kendoDataSourceErrorText(e),
                color: "danger",
                time: this.$store.getters.notificationDuration,
            });
        },
        beforeSend: function (req) {
            if (this.authToken) {
                req.setRequestHeader(
                    "Authorization",
                    "Bearer " + this.authToken
                );
            }
        },
        parameterMap: function (options, operation) {
            if (operation !== "read" && options.models) {
                return { models: kendo.stringify(options.models) };
            } else {
                return kendo.stringify(options);
            }
        },
        activeCellTemplate: function (dataItem) {
            let templateHtml =
                '<div class="text-center"><span class="badge ' +
                (dataItem.active ? "badge-success" : "badge-danger") +
                '">' +
                kendo.htmlEncode(
                    dataItem.active ? this.$t("yes") : this.$t("no")
                ) +
                "</span></div>";

            return templateHtml;
        },
        btnsTemplate: function (e) {
            return {
                template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                templateArgs: {
                    ...e,
                    parentComponent: this.$refs.grid,
                    btns: [
                        {
                            name: "edit",
                            text: "",
                            tooltip: this.$t("buttons.edit.btnText"),
                            class: "btn btn-primary",
                            icon: "fas fa-edit",
                            show: this.hasEditRights,
                            clickHandler: this.editBtnClick,
                        },
                        {
                            name: "deactivation",
                            text: "",
                            tooltip: this.$t("buttons.deactivate.btnText"),
                            class: "btn btn-danger",
                            icon: "fas fa-lock",
                            show: e.active && this.hasDeleteRights,
                            clickHandler: this.deactivateBtnClick,
                        },
                        {
                            name: "activation",
                            text: "",
                            tooltip: this.$t("buttons.activate.btnText"),
                            class: "btn btn-success",
                            icon: "fas fa-lock-open",
                            show: !e.active && this.hasDeleteRights,
                            clickHandler: this.activateBtnClick,
                        },
                    ],
                },
            };
        },
        editBtnClick: function (args) {
            if (!this.hasEditRights) {
                return this.$router.push(`/unauthorized`);
            }

            this.$router.push(`/auxiliary/${args.id}/edit`);
        },
        deactivateBtnClick(args) {
            if (!this.hasDeleteRights) {
                return this.$router.push(`/unauthorized`);
            }

            if (!args.active) {
                this.$vs.notify({
                    title: this.$t("buttons.deactivate.action"),
                    text: this.$t("buttons.deactivate.already"),
                    color: "warning",
                    time: this.$store.getters.notificationDuration,
                });

                return;
            }

            service.deactivate(args.id)
                .then((response) => {
                    this.$vs.notify({
                        title: this.$t("buttons.deactivate.action"),
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t("buttons.deactivate.action"),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => { this.refresh() });
        },
        activateBtnClick(args) {
            if (!this.hasDeleteRights) {
                return this.$router.push(`/unauthorized`);
            }

            if (args.active) {
                this.$vs.notify({
                    title: this.$t("buttons.activate.action"),
                    text: this.$t("buttons.activate.already"),
                    color: "warning",
                    time: this.$store.getters.notificationDuration,
                });

                return;
            }

           service.activate(args.id)
                .then((response) => {
                    this.$vs.notify({
                        title: this.$t("buttons.activate.action"),
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t("buttons.activate.action"),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => { this.refresh() });
        },
        refresh() {
            const grid = this.$refs.grid;
            if (grid) {
                grid.kendoWidget().dataSource.read();
            }
        }
    },
    mounted: function () {
        var container = $(this.$el);
        container.find('[data-toggle="tooltip"]').tooltip({ container });
    },
    computed: {
        ...mapGetters(['gridOptions', 'authToken', 'isEnVersion', 'claims', 'dateTimeLongFormat']),
        hasCreateRights() {
            return this.claims.auxiliaryRegister.create;
        },
        hasEditRights() {
            return this.claims.auxiliaryRegister.update;
        },
        hasDeleteRights() {
            return this.claims.auxiliaryRegister.delete;
        },
        dateTimeCustomFormat() {
            return `{0: ${this.dateTimeLongFormat} }`;
        },
    },
};
</script>

<style scoped>
</style>
